<template>
  <div class="row main-content">
    <div class="col">
      <h1 class="page-title font-custom text-uppercase mt-3">
        {{ $t('title.request.list') }}
      </h1>

      <div
        class="card rounded-0 mb-4"
      >
        <form
          class="card-body"
          @submit.prevent="getRequests"
        >
          <div class="row mb-2">
            <!-- Distributor -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.request.distributorRef') }}
              </label>
              <select
                v-model="criterias.selectedDistributorRef"
                :disabled="isDistributorLocked"
                name="distributor"
                class="form-control rounded-0 form-select"
                :data-placeholder="$t('label.request.distributorRef')"
                @change="updateComProducts()"
              >
                <option
                  value="null"
                  selected
                >
                  {{ $t('label.request.distributorDefaultAll') }}
                </option>
                <option
                  v-for="distributor in distributors"
                  :key="distributor.id"
                  :value="distributor"
                >
                  {{ distributor }}
                </option>
              </select>
            </div>
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.request.productRef') }}
              </label>
              <input
                v-model="criterias.productRef"
                type="text"
                class="form-control rounded-0"
                :placeholder="$t('label.request.productRef')"
              >
            </div>
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.request.requestStatus') }}
              </label>
              <select
                v-model="criterias.requestStatus"
                name="requestStatus"
                class="form-control rounded-0 form-select"
                :data-placeholder="$t('label.request.requestStatus')"
              >
                <option
                  :value="null"
                  selected
                >
                  {{ $t('label.request.allStatus') }}
                </option>
                <option
                  v-for="status in allStatus"
                  :key="status"
                  :value="status.value"
                >
                  {{ $t('label.request.' + status.value) }}
                </option>
              </select>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col justify-content-end text-end criteria-button">
              <button
                type="button"
                class="btn btn-default btn-reset rounded-pill font-custom me-2"
                @click="reset()"
              >
                {{ $t('button.reset') }}
              </button>
              <button
                class="btn btn-primary btn-submit rounded-pill font-custom text-uppercase font-inverted"
                type="button"
                @click="getRequests()"
              >
                <i class="fa fa-search me-1" />
                {{ $t('button.search') }}
              </button>
            </div>
          </div>
        </form>
      </div>

      <div v-if="$store.state.requests.requests.length">
        <div class="table-responsive">
          <table
            class="table table-hover table-sm table-striped border"
            style="white-space:nowrap;"
          >
            <thead>
              <tr>
                <th>{{ $t('label.request.requestId') }}</th>
                <th>{{ $t('label.request.distributorRef') }}</th>
                <th>{{ $t('label.request.productRef') }}</th>
                <th>{{ $t('label.request.requestStatus') }}</th>
                <th>{{ $t('label.request.requestDate') }}</th>
                <th>{{ $t('label.request.requestType') }}</th>
                <th>{{ $t('label.request.requestUser') }}</th>
                <th>{{ $t('label.actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="request in displayedRequests"
                :key="request.requestID"
                class="mb-3"
              >
                <td>{{ request.requestID }}</td>
                <td>{{ request.distributorRef }}</td>
                <td>{{ request.productRef }}</td>
                <td>{{ $t('label.request.' + request.requestStatus) }}</td>
                <td>{{ $filters.dateYYYYMMDDTirets(request.requestDate) }}</td>
                <td>{{ request.requestType }}</td>
                <td>{{ request.requestUser }}</td>
                <td>
                  <button
                    v-if="hasPermission('product:create')"
                    type="button"
                    class="btn btn-sm btn-outline-secondary border-secondary rounded-pill font-custom me-2"
                    @click="showDetails(request.requestID)"
                  >
                    {{ $t('button.detail') }}
                  </button>
                  <!-- <button
                    v-if="request.requestStatus === 'PENDING' && hasPermission('product:create')"
                    type="button"
                    class="btn btn-sm btn-primary font-custom rounded-pill border me-2"
                    @click="showEdit(request.requestID)"
                  >
                    {{ $t('button.edit') }}
                  </button> -->
                  <BaseButton
                    v-if="request.requestStatus === 'PENDING' && hasPermission('product:create')"
                    type="button"
                    class="btn btn-sm btn-danger font-custom rounded-pill border me-2"
                    data-bs-toggle="modal"
                    data-bs-target="#cancelModal"
                    @click="setRequestID(request.requestID)"
                  >
                    {{ $t('button.cancel') }}
                  </BaseButton>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <Pager
          :posts="$store.state.requests.requests"
          @page-update="displayedRequests = $event;"
        />
      </div>

      <div
        v-if="isProcessing"
        class="text-center"
      >
        <img
          src="@/assets/img/loader.gif"
          class="center-block lazyload"
        >
      </div>

      <div
        v-else-if="error"
        class="alert alert-warning text-center border-0 shadow-sm rounded-0"
      >
        {{ $t('error.'+`${responseErr}`) }}
      </div>

      <!-- Cancel modal validation -->
      <div
        id="cancelModal"
        class="modal fade"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
              <h4 class="modal-title">
                {{ $t('label.request.requestCancellation') }}
              </h4>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
              />
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-default"
                data-bs-dismiss="modal"
              >
                {{ $t('button.cancel') }}
              </button>
              <BaseButton
                type="button"
                class="btn btn-primary"
                data-bs-dismiss="modal"
                @click-base-button-event-emitter="cancel()"
              >
                {{ $t('button.confirm') }}
              </BaseButton>
            </div>
          </div>
        </div>
      </div>
    </div>

    <SuccessDialog ref="successDialogRef" />
  </div>
</template>

<script src="./RequestList.js"></script>

<style src="./RequestList.scss" scoped lang="scss"></style>
